<div class="tw-relative tw-py-8 tw-px-6 tw-rounded-lg tw-max-w-md tw-mx-auto tw-bg-white">
    <div class=" tw-text-black ">
        <button
          aria-label="Close modal"
          class="tw-absolute tw-top-2 tw-right-1 tw-text-xl tw-font-bold tw-cursor-pointer tw-bg-transparent"
          (click)="activeModal.dismiss()"
          type="button"
        >
          &times;
        </button>
     
    </div>
    <div class="tw-flex tw-flex-col tw-items-center tw-gap-4 tw-text-center tw-p-4">
                <img
                src="/assets/img/icons/common/check_circle.png"
                alt="Success Icon"
                class="tw-w-12 tw-h-12"
            />
        
        <div class="tw-text-primary tw-font-bold tw-text-red-600">
            {{ 'support.successMessage' | translate }}
        </div>
    </div>
</div>
  